export default "__VITE_ASSET__BxNljl8E__";